import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { ClientStatementForm } from 'common/forms';
import { managementCompaniesSelectionChanged } from 'common/forms/ClientStatementForm/managementCompanies';
import { ClientStatementFormValues } from 'common/models/Forms';

import { QuestionTitle, PageControls } from '../../../../components';
import {
  selectAgreementRequestInfo,
  selectProtocolCustomerStatement,
  setAgreementRequestInfoAction,
  setProtocolCustomerStatementValuesAction,
} from '../../../../ducks';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function ProtocolCustomerStatementFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customerStatement = useSelector(selectProtocolCustomerStatement);
  const agreementRequestInfo = useSelector(selectAgreementRequestInfo);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<ClientStatementFormValues>();

  function handleBackClick() {
    navigate(`/form/${id}/protocol/initiation`);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<ClientStatementFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: ClientStatementFormValues) {
    if (!isPrivileged) {
      const companiesChanged = managementCompaniesSelectionChanged(customerStatement?.b, values.b);
      if (companiesChanged && agreementRequestInfo) {
        dispatch(setAgreementRequestInfoAction({ ...agreementRequestInfo, a: '' }));
      }
      dispatch(setProtocolCustomerStatementValuesAction(values));
    }
    navigate(`/form/${id}/protocol/customer-confirmation`);
  }

  return (
    <>
      <QuestionTitle>{t('protocolFeature.customerStatement')}</QuestionTitle>
      <ClientStatementForm
        initialValues={customerStatement || undefined}
        bindSubmit={bindSubmit}
        onSubmit={handleSubmit}
      />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
